/**
 * Page-to-page loader: when a visitor follows a link to another page in the store, the Monk
 * swoosh breathes on a black screen until the next page arrives. Only shown if navigation takes
 * longer than DELAY ms, so fast pages never flash. Skips new tabs, downloads, in-page anchors,
 * external links and modified clicks; clears itself when returning via the back button.
 */
const DELAY = 300;
const root = document.documentElement;
let timer = 0;

function show() {
  clearTimeout(timer);
  timer = setTimeout(() => root.classList.add('is-navigating'), DELAY);
}

function hide() {
  clearTimeout(timer);
  root.classList.remove('is-navigating');
}

document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
  if (!link || link.target && link.target !== '_self' || link.hasAttribute('download')) return;
  const url = new URL(link.href, location.href);
  if (url.origin !== location.origin) return;
  if (!/^https?:$/.test(url.protocol)) return;
  if (url.pathname === location.pathname && url.search === location.search) return; // same page / anchor
  // Let other handlers (drawers, quick actions) decide first.
  queueMicrotask(() => { if (!event.defaultPrevented) show(); });
});

window.addEventListener('pageshow', hide);
window.addEventListener('pagehide', () => clearTimeout(timer));
